import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Tabel } from 'src/app/interfaces/auth.interface';
import { CheckoutService } from 'src/app/services/checkout.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ThrowStmt } from '@angular/compiler';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  isUser:boolean =false

//  @Input('tableno') info: Tabel;


  tableno:number = null

  linkRef: AngularFirestoreDocument<any>;

  linkRef2: AngularFirestoreCollection<any>;

  link: Observable<any>;

  link2: Observable<any>;

  tabel: Tabel[] = [];

  id: string = '' 

  length:number = null

  ulTrue:boolean = true


  constructor(private as: AuthService,
              private fs: AngularFirestore,
              private checkout: CheckoutService,
              private router:Router,
              public translate: TranslateService)
               {
                this.currentLang = localStorage.getItem('currentLang') || 'ar';
                this.translate.use(this.currentLang)
               }

  ngOnInit(): void {
    
    this.as.user.subscribe(user => {
      
      if(user) {
        
        this.isUser =true;

        this.as.userId = user.uid;

        this.as.userEmail = user.email;

        this.id = user.uid;

      }

      else {
       
        this.isUser = false;
       
        this.as.userId = '';
      
      } 

      this.linkRef = this.fs.collection('users').doc(`${this.id}`)
   
      this.link = this.linkRef.valueChanges();
 
      this.link.subscribe(data=> {
        this.tableno = data.tableno
      })
      
      
      this.linkRef2 = this.fs.collection('users').doc(`${this.id}`).collection('order')
   
      this.link2 = this.linkRef2.valueChanges();
 
      this.link2.subscribe(data=> this.length = data.length)


      this.linkRef2 = this.fs.collection('users').doc(`${this.id}`).collection('ordersubinfo')
   
      this.link2 = this.linkRef2.valueChanges();
 
      this.link2.subscribe(data=>{
        this.checkout.orderSubInfoLength = data.length;
      } )
    })
    if (window.innerWidth < 769) {
      document.getElementById("vincent_header_right").classList.add("vincent_header_x");
      document.getElementById("vincent_header_right").classList.remove("vincent_header_right");  
    }
    this.translate.onLangChange.subscribe( ()=> {
      if(this.translate.currentLang == "en") {
        this.en = false;
        this.ar = true;
        document.getElementById("menu").classList.remove("vincent_menu_ar")
        document.getElementById("menu").classList.add("vincent_menu_en")
      }
      else if(this.translate.currentLang == "ar") {
        this.en = true;
        this.ar = false;
        document.getElementById("menu").classList.remove("vincent_menu_en")
        document.getElementById("menu").classList.add("vincent_menu_ar")
      }
    })
  }


   updateNo(tableno){
      this.fs.collection('users').doc(`${this.id}`).update({
       tableno
     })
     .then(()=> {
      document.getElementById('basic').style.display="none"
      document.getElementById('changed').style.display="block";
      setTimeout(()=>{
        document.getElementById('changed').style.display="none";
        document.getElementById('basic').style.display="block";
      }, 2000);
    })
   }
   Open:boolean = false;

   Close:boolean = true;

  open() {
    this.ulTrue = true
    this.Open = false
    this.Close = true
    document.getElementById("vincent_header_right").classList.add("vincent_header_x");
    document.getElementById("vincent_header_right").classList.remove("vincent_header_right");
  }
  close() {
    this.ulTrue = false
    this.Close = false
    this.Open = true
    document.getElementById("vincent_header_right").classList.remove("vincent_header_x");
    document.getElementById("vincent_header_right").classList.add("vincent_header_right");
  }
  logout(){
    this.as.logout()
  }
  goCart(){
    this.router.navigate(['./cart'])
  }
  ar:boolean = false
  en:boolean = true
  currentLang:string;
  
  show_ar() {
    this.ar = false
    this.en = true
  }
  show_en() {
    this.ar = true
    this.en = false
  }
  changeCurrentLang(lang:string) {
    this.translate.use(lang);
    localStorage.setItem('currentLang',lang)
  }
}
